import Subscription from "@repo/kikoff-models/Subscription";
import Telemetry from "@repo/telemetry";
import Country from "@repo/utils/Country";
import Locale from "@repo/utils/Locale";
import Money from "@repo/utils/Money";
import UDate from "@repo/utils/UDate";

import { AnalyticsEvents } from "./analytics/client";

export type AppSettings = {
  country: Country;
  currency: Money.Currency;
  dateFormat: Parameters<typeof UDate.parse>[1];
  locales: [Locale, ...Locale[]];
  phone: {
    requireMarketingSmsConsent: boolean;
  };
  support: {
    email: string;
    phone?: string;
  };
  marketing: {
    facebookId: string;
    gtmId: string;
    gtagId: string;
    tiktokId: string;
    podscribeId?: string;
    snapchatId?: string;
    clarityId?: string;
    impactRadius: {
      trackingIdByConversionEvent: Record<
        keyof AnalyticsEvents["conversion"],
        number
      >;
    };
    ltvByTier: Record<Subscription.Tier, number>;
  };
};

const appSettings = (
  import.meta.env.API_ADAPTER === "us"
    ? {
        country: "US",
        currency: "USD",
        locales: ["en"],
        dateFormat: "mm/dd/yyyy",
        phone: {
          requireMarketingSmsConsent: false,
        },
        support: {
          email: "support@kikoff.com",
          phone: "+1 (844) 741-9290",
        },
        marketing: {
          facebookId: "759796597839521",
          clarityId: "g95f9ieic7",
          gtmId: "GTM-KZDXSSZ",
          gtagId: "G-6203WK809M",
          tiktokId: "C11A1S104P0HGS266FGG",
          podscribeId: "d8656980-7862-4277-ac8d-6a5f81a2dc01",
          snapchatId: "cbced8f2-b7b3-4625-a265-1b47f05ca056",
          impactRadius: {
            trackingIdByConversionEvent: {
              Signup: 28111,
              "Credit Account Open": 28335,
              // TODO
              "Make Credit Line Payment": 0,
              SnapchatOnlyLogin: 0,
            },
          },
          ltvByTier: {
            basic: 44,
            premium: 200,
            ultimate: 300,
          },
        },
      }
    : {
        country: "CA",
        currency: "CAD",
        locales: ["en", "fr"],
        dateFormat: "yyyy-mm-dd",
        phone: {
          requireMarketingSmsConsent: true,
        },
        support: {
          email: "support@kikoff.ca",
        },
        marketing: {
          facebookId: "3934492436832739",
          gtmId: "GTM-KZDXSSZ",
          // For google adwords
          gtagId: "AW-590059496",
          tiktokId: "C11A1S104P0HGS266FGG",
          impactRadius: {
            trackingIdByConversionEvent: {
              // TODO
              Signup: 0,
              "Credit Account Open": 49795,
              "Make Credit Line Payment": 50609,
              SnapchatOnlyLogin: 0,
            },
          },
          ltvByTier: {
            basic: 55,
            premium: 185,
            get ultimate() {
              Telemetry.captureError(
                new Error(
                  "Attempted to get LTV for unsupported ultimate plan in Canada."
                )
              );

              return 0;
            },
          },
        },
      }
) as AppSettings;

export default appSettings;

Country.current = appSettings.country;
Money.currency = appSettings.currency;
